export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-testid="logo-mark">
    <path d="M32 2 58 16v32L32 62 6 48V16Z" fill="#0A0D08" stroke="#BDB096" strokeWidth="3" />
    <path d="M21 43 39 25" stroke="#FF4500" strokeWidth="6" strokeLinecap="square" />
    <circle cx="42" cy="22" r="7.5" fill="none" stroke="#BDB096" strokeWidth="5" />
  </svg>
);

export const Logo = () => (
  <a href="/" className="flex items-center gap-3 group" data-testid="site-logo">
    <LogoMark />
    <div className="leading-none">
      <span className="font-stencil text-sm sm:text-base tracking-wide text-foreground group-hover:text-khaki transition-colors duration-300">
        OPERATION FIX-IT
      </span>
      <span className="block text-[9px] tracking-[0.3em] text-coyote mt-1">
        HOME MAINTENANCE DIVISION
      </span>
    </div>
  </a>
);
